import React from "react";
import "./footer.scss"; // same styles as style.css

const Footer = () => {
	
	const InfoFooter = [
		{id: 1, url: '/about-us', urlname: 'About Us'},
		{id: 2, url: '/about-us', urlname: 'Service'},
		{id: 3, url:'/about-us', urlname: 'Collection'},
	]
	const ExploreFooter = [
		{id: 1, url: '/cheatsheets', urlname: 'Cheatsheets'},
		{id: 2, url: '/protfolio', urlname: 'Portfolio'},
		{id: 3, url:'https://medium.com/@thesupercodingbits' , urlname: 'Blogs'},
	]
	
	const SocialMediaFooter = [
		{id: 1, url: 'https://www.instagram.com/thesupercodingbits/', urlname: 'Instagram'},
		{id: 2, url: 'https://www.youtube.com/channel/UConIJKOfYtD4eiNFDPeucRw', urlname: 'YouTube'},
		{id: 3, url: 'https://medium.com/@thesupercodingbits', urlname: 'Medium'},
	]
	return (
		<section className="footer">
			<div className="footer-row">
				{/* Info Section */}
				<div className="footer-col">
					<h4>Info</h4>
					{
						InfoFooter.map((item, index) => (
							<ul className="links">
								<li><a href={item.url}>{item.urlname}</a></li>
							</ul>
						))
					}
				</div>
				
				{/* Explore Section */}
				<div className="footer-col">
					<h4>Explore</h4>
					{
						ExploreFooter.map((item, index) => (
							<ul className="links">
								<li><a href={item.url}>{item.urlname}</a></li>
							</ul>
						))
					}
					
				</div>
				
				{/* Legal Section */}
				<div className="footer-col">
					<h4>Social Media</h4>
					{
						SocialMediaFooter.map((item, index) => (
							<ul className="links">
								<li><a href={item.url}>{item.urlname}</a></li>
							</ul>
						))
					}
				</div>
				
				{/* Newsletter Section */}
				<div className="footer-col">
					<h4>Send Message</h4>
					<p>Send us a message with your questions, feedback, or ideas — we’d love to hear from you and will get back to you as soon as possible.</p>
					<form action="mailto:thesupercodingbits@gmail.com" method="POST" enctype="text/plain">
						<input type="text" placeholder="What's your message" required />
						<button type="submit">Send</button>
					</form>
				</div>
			</div>
		</section>
	);
};

export default Footer;
